module.exports = __webpack_public_path__ + "assets/img/2091591934007_.pic_hd.d3af919b.jpg";